import type { IconNode } from '../types';

/**
 * @name whistle
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgNnY0IiAvPgogIDxwYXRoIGQ9Ik0yMSA2YTEgMSAwIDAgMSAxIDF2MmExIDEgMCAwIDEtMSAxaC01LjY3NUE3IDcgMCAxIDEgOSA2eiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/whistle
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const Whistle: IconNode = [
  ['path', { d: 'M10 6v4' }],
  ['path', { d: 'M21 6a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-5.675A7 7 0 1 1 9 6z' }],
];

export default Whistle;
